import React from 'react';
import { useForm } from 'react-hook-form';
import { Button, useColorModeValue } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { EnvelopeSimple, Key } from 'phosphor-react';
import { useNavigate } from 'react-router-dom';
import { useFormValidationToast } from '../../../services/actionToast';
import { useAuth } from '../../../providers/auth';
import { InputForm } from '../../inputs/forms/InputForm';
import { FormButton } from '../../buttons/FormButton';
import { PasswordInputForm } from '../../inputs/forms/PasswordInputForm';

export default function HookForm() {
  const validationToast = useFormValidationToast();
  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs = [
    {
      name: 'username',
      value: process.env.NODE_ENV === 'development' ? 'adminuser@thinkidea.app' : '',
      placeholder: 'Digite o usuário',
      label: 'Usuário',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'password',
      value: process.env.NODE_ENV === 'development' ? '123456' : '',
      placeholder: 'Digite a senha',
      label: 'Senha',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const username = formInputs.find((field) => field.name === 'username');
  const password = formInputs.find((field) => field.name === 'password');

  const { Login } = useAuth();

  const onSubmit = async (values: any) => {
    // eslint-disable-next-line no-alert
    await Login(values);
  };
  const navigate = useNavigate();

  return (
    <form onSubmit={handleSubmit(onSubmit, validationToast)}>
      <InputForm
        name={username?.name}
        label={username?.label}
        placeholder={username?.placeholder}
        register={register}
        errors={errors}
        labelStyles={{ color: 'white' }}
        iconLeft={<EnvelopeSimple />}
      />

      <PasswordInputForm
        name={password?.name}
        label={password?.label}
        placeholder={password?.placeholder}
        register={register}
        errors={errors}
        labelStyles={{ color: 'white' }}
        iconLeft={<Key />}
      />
      <FormButton
        mt={4}
        variant="outline"
        backgroundColor={useColorModeValue('theme.light.body', 'theme.dark.body')}
        isLoading={isSubmitting}
        boxShadow="0px 2px 4px #00000050"
        border="none"
        type="submit"
        w="100%"
      >
        Entrar
      </FormButton>
      <Button
        marginTop={10}
        marginLeft={20}
        borderRadius="full"
        w="200px"
        variant="ghost"
        color="#EE7211"
        border="none"
        onClick={() => navigate('/recover')}
      >
        Esqueci a senha
      </Button>
    </form>
  );
}
